import React from "react";

import { bemModule } from "../../configs/bem";
import styles from "./menu-nav-placeholder.module.less";

const cn = bemModule(styles, "menu-nav-placeholder");
export function MenuNavPlaceholder(props) {
  return <div className={cn()} />;
}
